(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vk-reel-stage"] && !Shopify.designMode) return;
  try {
    (()=>{
const selector='[data-vk-reels-track],[data-vk-category-video-track],[data-vk-social-track],[data-vk-recent-video-track]';
function bind(track){
if(track.dataset.vkCircular)return;track.dataset.vkCircular='true';let busy=false,timer;
function arrange(){
if(busy||!matchMedia('(max-width:749px)').matches||track.clientWidth===0||track.children.length<3)return;
const rect=track.getBoundingClientRect(),center=rect.left+rect.width/2;
const cards=Array.from(track.children),card=cards.reduce((a,b)=>Math.abs(a.getBoundingClientRect().left+a.clientWidth/2-center)<Math.abs(b.getBoundingClientRect().left+b.clientWidth/2-center)?a:b);
if(card!==cards[0]&&card!==cards.at(-1))return;
busy=true;const before=card.getBoundingClientRect().left;track.style.setProperty('scroll-snap-type','none','important');track.style.setProperty('scroll-behavior','auto','important');
if(card===cards[0])track.prepend(cards.at(-1));else track.append(cards[0]);
track.scrollLeft+=card.getBoundingClientRect().left-before;
requestAnimationFrame(()=>requestAnimationFrame(()=>{track.style.removeProperty('scroll-snap-type');track.style.removeProperty('scroll-behavior');busy=false}));
}
track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(arrange,180)},{passive:true});new ResizeObserver(arrange).observe(track);
}
const init=()=>{document.querySelectorAll(selector).forEach(bind);const observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{if(!isIntersecting)target.pause();else if(target.muted)target.play().catch(()=>{})}),{threshold:0.1});document.querySelectorAll('.vk-luxe-hero__mobile-media,.vk-luxe-hero video').forEach(v=>observer.observe(v))};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
